var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F0E4EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3506 26.1376C18.6969 26.0307 16.5714 23.8402 16.5714 21.1609C16.5714 18.4143 18.8061 16.1789 21.5535 16.1789C24.301 16.1789 26.5356 18.4135 26.5356 21.1609C26.5356 23.1686 25.359 24.9579 23.5 25.7674H29.5146C30.2776 24.4304 30.7145 22.8069 30.7145 21.1609C30.7145 16.1091 26.6045 12 21.5535 12C16.5025 12 12.3926 16.1099 12.3926 21.1609C12.3926 26.212 16.5009 30.3219 21.5527 30.3219H33.3457V26.1423L21.3506 26.1376Z",
    fill: "#BF50B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4407 26.1522H12V30.2358H18.9247C16.6382 29.5867 14.6948 28.1104 13.4407 26.1522Z",
    fill: "#BF50B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupLogo);
export default __webpack_public_path__ + "static/media/GroupLogo.95ae8b16303c2accdce31a90d8bddf9a.svg";
export { ForwardRef as ReactComponent };